import GoalCompletionShareDialog from './GoalCompletionShareDialog';

export default GoalCompletionShareDialog;
